import { render, staticRenderFns } from "./Actions.vue?vue&type=template&id=0718d8ac&scoped=true&"
import script from "./Actions.vue?vue&type=script&lang=ts&"
export * from "./Actions.vue?vue&type=script&lang=ts&"
import style0 from "./Actions.vue?vue&type=style&index=0&id=0718d8ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0718d8ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
